import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'

const orgPosition = new RestResource({server: ORGANIZATION_SERVER, resource: 'orgPosition'});

export default orgPosition;